import {
  ANALYSIS_PROPERTIES_CLIENT_FAIL,
  ANALYSIS_PROPERTIES_CLIENT_REQUEST,
  ANALYSIS_PROPERTIES_CLIENT_SUCCESS,
  ANALYSIS_PROPERTIES_DESCRIPTION_FAIL,
  ANALYSIS_PROPERTIES_DESCRIPTION_REQUEST,
  ANALYSIS_PROPERTIES_DESCRIPTION_SUCCESS,
  ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_FAIL,
  ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_REQUEST,
  ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_SUCCESS,
  ANALYSIS_PROPERTIES_FAIL,
  ANALYSIS_PROPERTIES_LANGUAGE_FAIL,
  ANALYSIS_PROPERTIES_LANGUAGE_REQUEST,
  ANALYSIS_PROPERTIES_LANGUAGE_SUCCESS,
  ANALYSIS_PROPERTIES_REQUEST,
  ANALYSIS_PROPERTIES_RESULT_CATEGORY_FAIL,
  ANALYSIS_PROPERTIES_RESULT_CATEGORY_REQUEST,
  ANALYSIS_PROPERTIES_RESULT_CATEGORY_SUCCESS,
  ANALYSIS_PROPERTIES_SUCCESS,
  ANALYSIS_PROPERTIES_PATCH_REQUEST,
  ANALYSIS_PROPERTIES_PATCH_SUCCESS,
  ANALYSIS_PROPERTIES_PATCH_FAIL,
  ANALYSIS_PROPERTIES_USER_ENTITIES_REQUEST,
  ANALYSIS_PROPERTIES_USER_ENTITIES_SUCCESS,
  ANALYSIS_PROPERTIES_USER_ENTITIES_FAIL,
  ANALYSIS_PROPERTIES_LOCATION_REQUEST,
  ANALYSIS_PROPERTIES_LOCATION_SUCCESS,
  ANALYSIS_PROPERTIES_LOCATION_FAIL,
  ANALYSIS_PROPERTIES_USER_REQUEST,
  ANALYSIS_PROPERTIES_USER_SUCCESS,
  ANALYSIS_PROPERTIES_USER_FAIL,
  ANALYSIS_PROPERTIES_DEPARTMENT_REQUEST,
  ANALYSIS_PROPERTIES_DEPARTMENT_SUCCESS,
  ANALYSIS_PROPERTIES_DEPARTMENT_FAIL,
  ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_REQUEST,
  ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_SUCCESS,
  ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_FAIL,
  ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_REQUEST,
  ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_SUCCESS,
  ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_FAIL
} from '../../../../../constants/medical-record/analysis/data-analysis/data-analysis-properties'

const initialState = {
  loadingProperties: false,
  loadingLanguageSummary: false,
  loadingResultCategorySummary: false,
  loadingClientSummary: false,
  loadingDescription: false,
  loadingPatch: false,
  loadingSubmitUserEntity: false,
  loadingDetailUserEntity: false,
  loadingUserEntity: false,
  loadingLocation: false,
  loadingUser: false,
  loadingDepartment: false,
  configuration: {},
  languageSummary: [],
  descriptionsSummary: [],
  descriptionsTop10Summary: [],
  resultCategorySummary: [],
  clientSummary: [],
  userSummary: [],
  locationSummary: [],
  departmentSummary: [],
  pageable: {
    page: 1,
    size: 10,
    hits: 0
  },
  userEntitiesList: [],
  error: null
}

const dataAnalysisProperties = (state = initialState, action) => {
  switch (action.type) {
    case ANALYSIS_PROPERTIES_REQUEST:
      return { ...state, loadingProperties: true, configuration: {} }
    case ANALYSIS_PROPERTIES_SUCCESS:
      return {
        ...state,
        loadingProperties: false,
        configuration: action.payload
      }
    case ANALYSIS_PROPERTIES_FAIL:
      return { ...state, loadingProperties: false, error: action.payload }
    case ANALYSIS_PROPERTIES_LANGUAGE_REQUEST:
      return { ...state, loadingLanguageSummary: true, languageSummary: [] }
    case ANALYSIS_PROPERTIES_LANGUAGE_SUCCESS:
      return {
        ...state,
        loadingLanguageSummary: false,
        languageSummary: action.payload
      }
    case ANALYSIS_PROPERTIES_LANGUAGE_FAIL:
      return { ...state, loadingLanguageSummary: false, error: action.payload }
    case ANALYSIS_PROPERTIES_RESULT_CATEGORY_REQUEST:
      return {
        ...state,
        loadingResultCategorySummary: true,
        resultCategorySummary: []
      }
    case ANALYSIS_PROPERTIES_RESULT_CATEGORY_SUCCESS:
      return {
        ...state,
        loadingResultCategorySummary: false,
        resultCategorySummary: action.payload
      }
    case ANALYSIS_PROPERTIES_RESULT_CATEGORY_FAIL:
      return {
        ...state,
        loadingResultCategorySummary: false,
        error: action.payload
      }
    case ANALYSIS_PROPERTIES_CLIENT_REQUEST:
      return { ...state, loadingClientSummary: true, clientSummary: [] }
    case ANALYSIS_PROPERTIES_CLIENT_SUCCESS:
      return {
        ...state,
        loadingClientSummary: false,
        clientSummary: action.payload
      }
    case ANALYSIS_PROPERTIES_CLIENT_FAIL:
      return { ...state, loadingClientSummary: false, error: action.payload }
    case ANALYSIS_PROPERTIES_PATCH_REQUEST:
      return { ...state, loadingPatch: action.payload }
    case ANALYSIS_PROPERTIES_PATCH_SUCCESS:
      return {
        ...state,
        loadingPatch: false
      }
    case ANALYSIS_PROPERTIES_PATCH_FAIL:
      return { ...state, loadingPatch: false, error: action.payload }
    case ANALYSIS_PROPERTIES_DESCRIPTION_REQUEST:
      return { ...state, loadingDescription: true, descriptionsSummary: [] }
    case ANALYSIS_PROPERTIES_DESCRIPTION_SUCCESS:
      return {
        ...state,
        loadingDescription: false,
        descriptionsSummary: action.payload
      }
    case ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_REQUEST:
      return {
        ...state,
        loadingDescription: true,
        descriptionsTop10Summary: []
      }
    case ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_SUCCESS:
      return {
        ...state,
        loadingDescription: false,
        descriptionsTop10Summary: action.payload
      }
    case ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_FAIL:
      return { ...state, loadingDescription: false, error: action.payload }
    case ANALYSIS_PROPERTIES_USER_ENTITIES_REQUEST:
      return {
        ...state,
        loadingUserEntity: true,
        userEntitiesList: []
      }
    case ANALYSIS_PROPERTIES_USER_ENTITIES_SUCCESS:
      return {
        ...state,
        loadingUserEntity: false,
        userEntitiesList: action.payload,
        pageable: action.pageable
      }
    case ANALYSIS_PROPERTIES_USER_ENTITIES_FAIL:
      return { ...state, loadingUserEntity: false, error: action.payload }
    case ANALYSIS_PROPERTIES_USER_REQUEST:
      return {
        ...state,
        loadingUser: true,
        userSummary: []
      }
    case ANALYSIS_PROPERTIES_USER_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        userSummary: action.payload
      }
    case ANALYSIS_PROPERTIES_USER_FAIL:
      return { ...state, loadingUser: false, error: action.payload }
    case ANALYSIS_PROPERTIES_LOCATION_REQUEST:
      return {
        ...state,
        loadingLocation: true,
        locationSummary: []
      }
    case ANALYSIS_PROPERTIES_LOCATION_SUCCESS:
      return {
        ...state,
        loadingLocation: false,
        locationSummary: action.payload
      }
    case ANALYSIS_PROPERTIES_LOCATION_FAIL:
      return { ...state, loadingLocation: false, error: action.payload }
    case ANALYSIS_PROPERTIES_DEPARTMENT_REQUEST:
      return {
        ...state,
        loadingDepartment: true,
        departmentSummary: []
      }
    case ANALYSIS_PROPERTIES_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loadingDepartment: false,
        departmentSummary: action.payload
      }
    case ANALYSIS_PROPERTIES_DEPARTMENT_FAIL:
      return { ...state, loadingDepartment: false, error: action.payload }
    case ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_REQUEST:
      return {
        ...state,
        loadingSubmitUserEntity: true
      }
    case ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_SUCCESS:
      return {
        ...state,
        loadingSubmitUserEntity: false
      }
    case ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_FAIL:
      return { ...state, loadingSubmitUserEntity: false, error: action.payload }
    case ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_REQUEST:
      return {
        ...state,
        loadingDetailUserEntity: true,
        userEntityDetail: {}
      }
    case ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_SUCCESS:
      return {
        ...state,
        loadingDetailUserEntity: false,
        userEntityDetail: action.payload
      }
    case ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_FAIL:
      return { ...state, loadingDetailUserEntity: false, error: action.payload }
    default:
      return state
  }
}

export default dataAnalysisProperties
